export const SET_IS_MENU_ACTIVE = 'isMenuActive'
export const SET_ACTIVE_TRACKING_ASIDE_TAB = 'setActiveTrackingAsideTab'

export default {
    isMenuActive (state, status) {
        state.isMenuActive = status
    },

    setActiveTrackingAsideTab (state, activeTab) {
        state.activeTrackingAsideTab = activeTab
    }
}
